import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lc-form-help-footer',
    standalone: true,
    imports: [CommonModule],
    template: `
        @if (showHelp) {
            <div class="help-footer">
                <div class="help-content">
                    <div class="help-icon">
                        <svg
                            class="h-4 w-4 text-blue-600 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                        </svg>
                    </div>
                    <span class="help-text">
                        <strong>{{ helpTitle || 'Dica:' }}</strong>
                        {{ helpMessage || 'Preencha todos os campos obrigatórios (*) para registrar o formulário corretamente' }}
                    </span>
                </div>
            </div>
        }
    `,
    styles: [
        `
            .help-footer {
                @apply mt-8 text-center;
            }

            .help-content {
                @apply inline-flex items-center px-4 py-2 bg-blue-50 dark:bg-blue-200 
                   border border-blue-200 dark:border-blue-800 rounded-lg;
            }

            .help-icon {
                @apply w-4 mr-2;
            }

            .help-text {
                @apply text-sm text-blue-700 dark:text-blue-800;
            }
        `,
    ],
})
export class FormHelpFooterComponent {
    @Input() showHelp: boolean = true;
    @Input() helpTitle?: string;
    @Input() helpMessage?: string;
}
